import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@mui/material/Grid';
import { Labeled } from 'react-admin';
import { useWatch, useFormContext } from 'react-hook-form';

import ContentImageItem from './content-image-item';

const ContentImagesInput = ({
    label = 'Expiration dates for embedded content images',
    source,
    validate,
    ...props
}) => {
    const { control, formState: { errors } } = useFormContext();
    const watchedValue = useWatch({ name: source, control });

    // Create input-like object for compatibility
    const input = React.useMemo(() => {
        const value = watchedValue || [];
        return {
            value,
        };
    }, [watchedValue]);

    // Create meta-like object for compatibility
    const meta = {
        touched: true,
        error: errors[source]?.message,
    };

    if (!input.value) return null;
    if (input.value.length === 0) return null;

    return (
        <Labeled
            fullWidth
            label={label}
            meta={meta}
            input={input}
            resource={props.resource}
            source={source}
        >
            <Grid container sx={{ width: '100%' }} spacing={1}>
                {
                    input.value.map((image) => (
                        <Grid key={image.id} size={12}>
                            <ContentImageItem image={image} />
                        </Grid>
                    ))
                }
            </Grid>
        </Labeled>
    );
};

ContentImagesInput.propTypes = {
    label: PropTypes.string,
    resource: PropTypes.string,
    source: PropTypes.string.isRequired,
    validate: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.arrayOf(PropTypes.func),
    ]),
};

export default ContentImagesInput;
